import { UserManager, WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts';

const oidcEnabled = import.meta.env.VITE_OIDC_ENABLED === 'true';
const oidcEnforced = import.meta.env.VITE_OIDC_ENFORCE === 'true';

const issuer = (import.meta.env.VITE_OIDC_ISSUER as string | undefined) || '';
const clientId = (import.meta.env.VITE_OIDC_CLIENT_ID as string | undefined) || '';
const scope = (import.meta.env.VITE_OIDC_SCOPE as string | undefined) || 'openid profile email';

const getOrigin = () => {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.origin;
};

const resolveRedirectUri = (value: string | undefined) => {
  if (!value) {
    return '';
  }
  if (value.startsWith('/')) {
    const origin = getOrigin();
    return origin ? `${origin}${value}` : value;
  }
  return value;
};

const redirectUri =
  resolveRedirectUri(import.meta.env.VITE_OIDC_REDIRECT_URI as string | undefined) ||
  (getOrigin() ? `${getOrigin()}/auth/callback` : '');
const postLogoutRedirectUri =
  resolveRedirectUri(import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI as string | undefined) ||
  (getOrigin() ? `${getOrigin()}/` : '');
const silentRedirectUri =
  resolveRedirectUri(import.meta.env.VITE_OIDC_SILENT_REDIRECT_URI as string | undefined) ||
  (getOrigin() ? `${getOrigin()}/auth/silent-callback` : '');

const userStore =
  typeof window !== 'undefined'
    ? new WebStorageStateStore({ store: window.sessionStorage })
    : undefined;

const oidcSettings: UserManagerSettings = {
  authority: issuer,
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  silent_redirect_uri: silentRedirectUri,
  response_type: 'code',
  scope,
  loadUserInfo: false,
  monitorSession: false,
  automaticSilentRenew: true,
  userStore,
};

const oidcUserManager = oidcEnabled ? new UserManager(oidcSettings) : null;

export const isOidcEnabled = () => oidcEnabled;
export const isOidcEnforced = () => oidcEnforced;
export { oidcSettings, oidcUserManager };
